export default __webpack_public_path__ + "static/char-s-14-cht-d2d06b973eccc9c1bc7b578181aff15a.webp";